import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

import FormGroup from 'components/v2/FormGroup';
import TextAreaForm from 'components/v2/TextAreaForm';
import Helptext from 'components/v2/FormHelptext';
import ShipmentResults from 'components/modules/tools/components/ShipmentResults';
import CargomaticCard from 'components/v2/card';
import Alert from 'components/ui/Alert';

export default function ShipmentDocuments() {
  const { t } = useTranslation();
  const REFERENCE_NUMBER_LIMIT = {
    UPPER: 20,
  };
  const [referenceNumbersText, setReferenceNumbersText] = useState('');
  const [referenceNumberCount, setReferenceNumberCount] = useState(0);
  const [referenceNumbers, setReferenceNumbers] = useState([]);

  function onReferenceNumbersChange(value) {
    setReferenceNumbersText(value);
    const _referenceNumberCount = value
      .replace(/\n/g, ',')
      .split(',')
      .filter((number) => number)?.length;
    setReferenceNumberCount(_referenceNumberCount);
  }

  async function handleSearch() {
    const numbers = referenceNumbersText
      .replace(/\n/g, ',')
      .split(',')
      .filter((number) => number);

    setReferenceNumbers(numbers);
  }

  function handleCancel() {
    setReferenceNumbers([]);
  }

  const isRefNumberLimitInRange =
    referenceNumberCount > 0 &&
    referenceNumberCount <= REFERENCE_NUMBER_LIMIT.UPPER;

  return (
    <div data-testid="shipmentDocumentsPanel">
      {referenceNumbers.length === 0 && (
        <CargomaticCard className="mb-6 max-w-xl">
          <Helptext className="mb-4">
            {t(
              'ENTER_A_LIST_OF_REFERENCE_NUMBERS_YOU_WOULD_LIKE_TO_DOWNLOAD_DOCUMENTS_FOR',
            )}
          </Helptext>
          {!!referenceNumberCount && (
            <Alert
              className="flex-1 mb-2"
              type={referenceNumberCount > 20 ? 'error' : 'info'}
              title={t('MAX_SEARCH_REF_NUMBER_LIMIT_EXCEEDED_ERROR', {
                current: referenceNumberCount,
                limit: REFERENCE_NUMBER_LIMIT.UPPER,
              })}
            />
          )}
          <FormGroup labelClassName="mb-1" label={t('REFERENCE_NUMBERS')}>
            <TextAreaForm
              placeholder={t('COMMA_SEPARATED_VALUES')}
              className="w-full"
              value={referenceNumbersText}
              onChange={onReferenceNumbersChange}
              actionName={t('SEARCH')}
              showAction
              rows={4}
              onActionClick={handleSearch}
              disabledBtn={!isRefNumberLimitInRange}
              name="commaSeparatedValues"
            />
          </FormGroup>
        </CargomaticCard>
      )}
      {referenceNumbers.length > 0 && (
        <ShipmentResults
          referenceNumbers={referenceNumbers}
          handleCancel={handleCancel}
        />
      )}
    </div>
  );
}
